export default __webpack_public_path__ + "static/media/sign-in.1f0d7f89.svg";